var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "partial-bankdraft-template" }, [
    _c(
      "section",
      { staticClass: "detail-section" },
      [
        _vm._l(_vm.partialbankdraftList, function (item) {
          return _c(
            "ul",
            {
              key: item.id,
              staticClass: "detail-list",
              on: {
                click: (e) => _vm.onClick(e, item),
                contextmenu: (e) => _vm.onRightClick(e, item),
              },
            },
            [
              _c("li", {
                staticClass:
                  "lf-icon-kebab-menu context-menu-launcher context-menu-container",
                on: { click: (e) => _vm.onRightClick(e, item) },
              }),
              _c("li", { staticClass: "detail-item" }, [
                _c("span", { staticClass: "detail-text" }, [
                  _vm._v(_vm._s(_vm.texts.paymentDate) + ":"),
                ]),
                _c("span", { staticClass: "detail-number" }, [
                  _vm._v(_vm._s(item.chargeDate)),
                ]),
              ]),
              _c("li", { staticClass: "detail-item" }, [
                _c("span", { staticClass: "detail-text" }, [
                  _vm._v(_vm._s(_vm.texts.amount) + ":"),
                ]),
                _c("span", { staticClass: "detail-number" }, [
                  _vm._v(_vm._s(_vm.formatAmount(item.amount)) + " €"),
                ]),
              ]),
              _c("li", { staticClass: "detail-item-description" }, [
                _c("span", { staticClass: "detail-text" }, [
                  _vm._v(_vm._s(_vm.texts.observations) + ":"),
                ]),
                _c("span", { staticClass: "detail-number" }, [
                  _vm._v(_vm._s(item.notes)),
                ]),
              ]),
            ]
          )
        }),
        _c("ejs-contextmenu", {
          ref: "partilBankdraftContextMenu",
          staticClass: "context-menu-component",
          attrs: {
            id: "partilBankdraftContextMenu",
            items: _vm.partialbankdraftContextMenuItems,
            select: _vm.onContextMenuClickItem,
            beforeClose: _vm.onContextMenuBeforeClose,
          },
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }